module.exports = __webpack_public_path__ + "img/saum_verkehrsgelb_ral1023.2d9a0be4.jpg";